import {type RefObject, useLayoutEffect, useState} from "react";

const MIN_HEIGHT = 400;
const BOTTOM_GAP = 16;

/**
 * Höhe, mit der ein Element vom eigenen Platz auf der Seite bis zum unteren Fensterrand reicht. Rechnet neu,
 * wenn sich das Fenster oder die Seite darüber ändert (z.B. eingeblendete Meldungen).
 */
export function useHeightToViewportBottom(ref: RefObject<HTMLElement | null>, active: boolean): number {
    const [height, setHeight] = useState(MIN_HEIGHT);
    useLayoutEffect(() => {
        const element = ref.current;
        if (!active || !element) return;
        const update = () => {
            const top = element.getBoundingClientRect().top + window.scrollY;
            setHeight(Math.max(MIN_HEIGHT, Math.floor(window.innerHeight - top - BOTTOM_GAP)));
        };
        update();
        const observer = new ResizeObserver(update);
        observer.observe(document.body);
        window.addEventListener("resize", update);
        return () => {
            observer.disconnect();
            window.removeEventListener("resize", update);
        };
    }, [ref, active]);
    return height;
}
